'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsInOfficeHours = undefined;

var _reselect = require('reselect');

var _getOfficeHoursStartTime = require('conversations-schema/availability/operators/getOfficeHoursStartTime');

var _getWidgetAvailabilityOptions = require('./getWidgetAvailabilityOptions');

var getIsInOfficeHours = exports.getIsInOfficeHours = (0, _reselect.createSelector)([_getWidgetAvailabilityOptions.getWidgetAvailabilityOptions], function (availabilityOptions) {
  return !(0, _getOfficeHoursStartTime.getOfficeHoursStartTime)(availabilityOptions);
});